exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ResultsGroup-f0ce39ee{margin:0 0 20px 0;position:relative}.ResultsGroup-f0ce39ee .heading-dff411e1{border-bottom:1px solid #E0E0E0;padding-top:5px;padding-bottom:5px;margin:15px 0 0 0}.ResultsGroup-f0ce39ee .leftRightPadding-d970d55b{padding-left:15px;padding-right:15px}.ResultsGroup-f0ce39ee .sectionTitle-223cc16c{margin:0 0}.ResultsGroup-f0ce39ee .sectionContent-a7992ccc{padding:10px 0 0 0}.ResultsGroup-f0ce39ee .sectionFooter-c6bb8cbd{padding:0 15px;font-size:13px;font-weight:500}\n", ""]);

// Exports
exports.locals = {
	"ResultsGroup": "ResultsGroup-f0ce39ee",
	"heading": "heading-dff411e1",
	"leftRightPadding": "leftRightPadding-d970d55b",
	"sectionTitle": "sectionTitle-223cc16c",
	"sectionContent": "sectionContent-a7992ccc",
	"sectionFooter": "sectionFooter-c6bb8cbd"
};